<template>
  <div class="flex flex-col gap-4">
    <ul class="flex list-none flex-wrap gap-4">
      <li
        v-for="(market, key) in markets.withBackbox"
        :key
        class="flex items-center gap-8"
      >
        <RevLink
          class="hover:no-underline"
          target="_blank"
          :to="market?.productPageLink?.href"
          :underlined="false"
        >
          <Pill
            custom-class="bg-static-success-low border-static-success-mid border-[0.1rem]"
            size="small"
            :tooltip-content="
              i18n(translations.hasBackboxTooltip, {
                country: i18n.country(key),
              })
            "
          >
            <template #default="{ flagSize, textSize }">
              <Flag v-if="market" :country-code="key" :size="flagSize" />
              <span :class="textSize">{{ key }} </span>
            </template>
          </Pill>
        </RevLink>
      </li>
      <li
        v-for="(market, key) in markets.withoutBackbox"
        :key
        class="flex items-center gap-8"
      >
        <RevLink
          class="hover:no-underline"
          target="_blank"
          :to="market?.productPageLink?.href"
          :underlined="false"
        >
          <Pill
            custom-class="bg-static-danger-low border-static-danger-hi border-[0.1rem]"
            size="small"
            :tooltip-content="
              i18n(translations.doesNotHaveBackboxTooltip, {
                country: i18n.country(key),
              })
            "
          >
            <template #default="{ flagSize, textSize }">
              <Flag v-if="market" :country-code="key" :size="flagSize" />
              <span :class="textSize">{{ key }} </span>
            </template>
          </Pill>
        </RevLink>
      </li>

      <li
        v-for="(market, key) in markets.offline"
        :key
        class="flex items-center gap-8"
      >
        <RevLink
          class="hover:no-underline"
          target="_blank"
          :to="market?.productPageLink?.href"
          :underlined="false"
        >
          <Pill
            custom-class="bg-static-default-mid-disabled border-action-brand-hi-disabled border-[0.1rem]"
            size="small"
            :tooltip-content="
              i18n(translations.offlineProductToolTip, {
                country: i18n.country(key),
              })
            "
          >
            <template #default="{ flagSize, textSize }">
              <Flag v-if="market" :country-code="key" :size="flagSize" />
              <span :class="textSize">{{ key }} </span>
            </template>
          </Pill>
        </RevLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import Flag from '@backmarket/nuxt-layer-base/components/Flag/Flag.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import type { ListingV2 } from '~/api/listings/types'

import Pill from '../Pill/Pill.vue'

import translations from './MarketList.translations'

const i18n = useI18n()

defineProps<{
  markets: ListingV2['markets']
}>()
</script>
